import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import PeriodFilterDates from "../../../components/PeriodFilterDates";
import { ReportsContext } from "./Reports";
import moment from "moment";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ClassesPopularity = () => {
    const canvasRef = useRef(null);
    const { t } = useTranslation();
    const { startDate, endDate } = useContext(ReportsContext);
    const [loading, setLoading] = useState(true);
    const { checkServerData } = useContext(BasicContext);
    const [classData, setClassData] = useState(null);

    const getData = async () => {
        const res = await postMethod("/get-class-popularity", { startDate: moment(startDate).format("YYYY-MM-DD"), endDate: moment(endDate).format("YYYY-MM-DD") });
        if (checkServerData(res)) {
            setClassData(res.data.data);
            //console.log(res.data.data);
        }
        setLoading(false);
    };

    const labels = () => {
        const list = [];
        classData.forEach((e) => {
            list.push(e.class_name);
        });
        return list;
    };

    const bgColors = () => {
        const list = [];
        classData.forEach((e) => {
            list.push("#cb7973");
        });
        return list;
    };

    const occurences = () => {
        const list = [];
        classData.forEach((e) => {
            list.push(e.occurrences);
        });
        return list;
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const filterDates = () => {
        setLoading(true);
        setTimeout(() => {
            getData();
        }, 500);
    };

    useEffect(() => {
        if (classData)
            if (classData.length > 0) {
                if (canvasRef.current) {
                    const numBars = classData.length;
                    const barThickness = 50;
                    const padding = 30;
                    canvasRef.current.height = numBars * (barThickness + padding);
                }
            }
    }, [classData]);

    return (
        <Fragment>
            <Container fluid className="pt-3 bg-white">
                <Row>
                    <Col xs={12}>
                        <PeriodFilterDates filterDates={filterDates} />
                    </Col>
                    {loading ? (
                        <Col className="text-center">
                            <p className="my-3">
                                <FontAwesomeIcon icon={faSpinner} className="rotate-center me-2" />
                                {t("loading")}
                            </p>
                        </Col>
                    ) : (
                        <Fragment>
                            {classData && (
                                <Fragment>
                                    <Col xs={12}>
                                        {classData.length === 0 ? (
                                            <p className="opacity-75 fs-6 text-center my-3">{t("noData")}</p>
                                        ) : (
                                            <Bar
                                                id="myChart"
                                                options={{
                                                    indexAxis: "y",
                                                    responsive: true,
                                                    plugins: {
                                                        title: {
                                                            display: true,
                                                            text: t("reports.classPopularity"),
                                                            font: {
                                                                family: "JosefinSans-Regular",
                                                                size: 16,
                                                            },
                                                            align: "start",
                                                            padding: {
                                                                top: 32,
                                                                bottom: 32,
                                                            },
                                                        },
                                                        legend: {
                                                            display: false,
                                                        },
                                                    },
                                                    scales: {
                                                        x: {
                                                            ticks: {
                                                                font: {
                                                                    family: "JosefinSans-Regular",
                                                                },
                                                                stepSize: 1,
                                                                precision: 0,
                                                            },
                                                        },
                                                        y: {
                                                            ticks: {
                                                                font: {
                                                                    family: "JosefinSans-Regular",
                                                                },
                                                                autoSkip: false,
                                                                /* callback: function (value) {
                                                                    const label = this.getLabelForValue(value);

                                                                    if (label.length <= 15) return label;

                                                                    const spaceIndices = [];
                                                                    for (let i = 0; i < label.length; i++) {
                                                                        if (label[i] === " ") {
                                                                            spaceIndices.push(i);
                                                                            if (spaceIndices.length === 2) break;
                                                                        }
                                                                    }

                                                                    if (spaceIndices.length >= 2) {
                                                                        const breakIndex = spaceIndices[1];
                                                                        return [label.slice(0, breakIndex), label.slice(breakIndex + 1)];
                                                                    }

                                                                    return label;
                                                                }, */
                                                            },
                                                        },
                                                    },
                                                }}
                                                data={{
                                                    labels: labels(),
                                                    datasets: [
                                                        {
                                                            data: occurences(),
                                                            backgroundColor: bgColors(),
                                                        },
                                                    ],
                                                }}
                                            />
                                        )}
                                    </Col>
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default ClassesPopularity;
